'use client';

import type { FC } from 'react';

import type { PromotionTallBannerSwipeItemType } from '@weberus/shared-types';
import Image from 'next/image';

interface PromotionTallBannerSwipeItemTypeProps extends PromotionTallBannerSwipeItemType {
  onClick?: (ev: React.MouseEvent<HTMLAnchorElement>) => void;
  isPriority?: boolean;
  width: number; // unit of pixels
  height: number;
}

export const PromotionTallBannerSwipeItem: FC<PromotionTallBannerSwipeItemTypeProps> = ({
  image,
  alt,
  action,
  onClick,
  width,
  height,
}) => {
  return (
    <a className="block w-full" href={action.web} onClick={(ev) => onClick?.(ev)}>
      <Image
        alt={alt}
        className="h-auto w-full rounded-12 object-contain pc:rounded-12"
        src={image.url}
        width={width}
        height={height}
        style={{ width: `${width}px`, height: `${height}px` }}
        priority
        unoptimized
      />
    </a>
  );
};
